import React from 'react';

export default function Skeleton({ rows = 4 }) {
  return (
    <div className="animate-pulse space-y-2" aria-hidden="true">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="h-11 bg-[#f1f5f9] rounded-lg" />
      ))}
    </div>
  );
}
